module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_gettogethers-1c86daa9399693fefcb3fe1fe3a264c5.jpg";